var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextAlignJustify = function SvgIconTextAlignJustify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.375a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zM3.75 9.125a1 1 0 0 0 0 2h16.5a1 1 0 1 0 0-2zM2.75 13.875a1 1 0 0 1 1-1h16.5a1 1 0 1 1 0 2H3.75a1 1 0 0 1-1-1M3.75 16.625a1 1 0 1 0 0 2h16.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconTextAlignJustify;